import { cn } from '#lib/helpers/class.js';
import { Icon } from '@iconify-icon/react';

export const Tag = (props) => {
    const { tag, checked, handleSelectTag, disabled } = props;
    return (
        <li
            className={cn(
                'flex justify-between transition-all',
                disabled
                    ? 'hidden'
                    : 'hover:bg-neutral-100 p-1 pl-2 border border-neutral-200 bg-white rounded-lg shadow-md'
            )}
        >
            <div className="flex">
                <input
                    type="checkbox"
                    className="cursor-pointer"
                    id={tag.id}
                    checked={checked}
                    onChange={() => handleSelectTag(tag, checked)}
                    disabled={disabled}
                />
                <label htmlFor={tag.id} className="pl-2 cursor-pointer">
                    {tag.name}
                </label>
            </div>
        </li>
    );
};

export const SelectedTag = (props) => {
    const { tag } = props;
    return (
        <li className="px-3 py-1 flex items-center bg-primary-600 shadow-md text-white font-semibold text-xs rounded-2xl">
            <span>{tag.name}</span>
        </li>
    );
};

export const ItineraryTag = (props) => {
    const { tag, remove } = props;
    return (
        <li className="pl-2 pr-1 py-1 flex gap-2 items-center bg-white border border-neutral-300 shadow-md font-semibold text-xs rounded-2xl">
            <span>{tag.name}</span>
            <div
                className="w-5 h-5 p-[2px] rounded-[50%] cursor-pointer transition-all text-neutral-600 hover:text-black hover:bg-neutral-200"
                onClick={() => remove(tag.id)}
            >
                <Icon icon="f7:xmark-circle" width="1rem" height="1rem" />
            </div>
        </li>
    );
};

export const Etcetera = () => (
    <div className="flex items-center p-1 bg-primary-600 shadow-md text-white font-semibold text-sm rounded-2xl">
        <Icon icon="tabler:dots" width="1.1rem" height="1.1rem" />
    </div>
);
